import axios from "axios";
import { baseUrl } from "./env";
const storedToken = localStorage.getItem("token");
// const accessToken=  localStorage.getItem("access_token")
// const rF = localStorage.getItem("userId")


//const baseUrl = "http://172.16.100.57:8080";



export const signIn = async (formData) => {
  return await axios.post(`${baseUrl}/api/auth/login-admin`, formData, {
    headers: {
      "content-Type": "application/json",
    },
  });
};

export const getProfile = async () => {
  return axios.get(`${baseUrl}/api/admin/get`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const updateProfile = async (profileData) => {
  return await axios.patch(`${baseUrl}/api/admin/update`, profileData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const changePassword = async (passwordData) => {
  return await axios.patch(
    `${baseUrl}/api/admin/change-password`,
    passwordData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
};

export const getAllQueries = async () => {
  return axios.get(`${baseUrl}/api/queries/get/all`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

// export const getDomain = async () => {
//   return axios.get(`${baseUrl}/api/domains/admin/all`, {
//     headers: {
//       Authorization: `Bearer ${storedToken}`,
//     },
//   });
// };

// export const DeleteDomain = async (id) => {
//   return axios.delete(`${baseUrl}/api/domains/delete/${id}`, {
//     headers: {
//       Authorization: `Bearer ${storedToken}`,
//     },
//   });
// };

// export const createDomain = async (newDomainName) => {
//   const formData = new FormData();
//   formData.append("domainName", newDomainName.domainName);
//   newDomainName.images.forEach((image) => {
//     formData.append("images", image);
//   });

//   return await axios.post(`${baseUrl}/api/domains/create`, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       Authorization: `Bearer ${storedToken}`,
//     },
//   });
// };




// export const UpdateDomain = async (id, updatedData) => {
//   console.log("update..", updatedData);

//   const formData = new FormData();
//   formData.append("domainName", updatedData.domainName);

//   // Append all domainImages if it's an array
//   updatedData.domainImages.forEach((image, index) => {
//     formData.append("images", image);
//   });

//   return await axios.put(
//     `${baseUrl}/api/domains/update/${id}`,
//     formData, // Pass formData as the request body
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${storedToken}`,
//       },
//     }
//   );
// };







// Delete Image
// export const DeleteImage = async (imageId) => {
//   return axios.delete(`${baseUrl}/api/domains/image/${imageId}`, {
//     headers: {
//       Authorization: `Bearer ${storedToken}`,
//     },
//   });
// };

// Fetch all equipment
export const getEquipment = async () => {
  return await axios.get(`${baseUrl}/api/equipment/all`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

// Create a new equipment
export const createEquipment = async (equipmentName) => {
  return await axios.post(`${baseUrl}/api/equipment/create`, equipmentName, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

// Delete equipment by ID
export const deleteEquipment = async (id) => {
  return await axios.delete(`${baseUrl}/api/equipment/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

// Update equipment by ID
export const updateEquipment = async (id, equipmentName) => {
  return await axios.put(
    `${baseUrl}/api/equipment/update/${id}`,
    { equipmentName },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
};

// project modules

export const getAllProjects = async () => {
  return await axios.get(`${baseUrl}/api/projects/admin/projects`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const deleteProject = async (id) => {

  return axios.delete(`${baseUrl}/api/projects/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const deleteProjectTask = async (id) => {
  return axios.delete(`${baseUrl}/api/projects/delete-task/${id}`);
};

// update project
export const updateProjectDetails = async (projectDetails) => {
  console.log("bcscksks", projectDetails)

  const formData = new FormData();

  // Only append if the value is not undefined or null
  // if (projectDetails.description) formData.append("projectDescription", projectDetails.description);
  // if (projectDetails.name) formData.append("projectName", projectDetails.name);
  // if (projectDetails.number) formData.append("projectNumber", projectDetails.number);
  // if (projectDetails.endDate) formData.append("dueDate", projectDetails.endDate);
  // if (projectDetails.startDate) formData.append("projectStartDate", projectDetails.startDate);
  // if (projectDetails.budget) formData.append("budget", projectDetails.budget);
  // if (projectDetails.projectAddress) formData.append("projectAddress", projectDetails.projectAddress);

  // // Only append tasks if tasks exist and are not empty
  // if (Array.isArray(projectDetails.tasks) && projectDetails.tasks.length > 0) {
  //   projectDetails.tasks.forEach((task) => {
  //     if (task) formData.append("tasks", task); // Only append if the task is not undefined/null
  //   });
  // }

  return axios.put(
    `${baseUrl}/api/projects/update/${projectDetails.id}`,
    projectDetails, // Send the formData in the body
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json", // Important for sending FormData
      },
    }
  );
};


// Create Project Api

export const createProjectDetails = async (projectDetails) => {

  // const formData = new FormData();
  // formData.append("projectDescription", projectDetails.description);
  // formData.append("projectName", projectDetails.name);
  // formData.append("dueDate", projectDetails.endDate);
  // formData.append("startDate", projectDetails.startDate);
  // formData.append("projectAddress",projectDetails.projectAddress)
  // formData.append("budget", projectDetails.budget);
  // formData.append("projectNumber", projectDetails.number);


  // projectDetails.tasks.forEach((task, index) => {
  //   formData.append("taskName", task.taskName);
  //   formData.append("taskBudget", task.taskBudget);
  // });

  return axios.post(
    `${baseUrl}/api/projects/create`,
    projectDetails, // Send the formData in the body
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json", // Important for sending FormData
      },
    }
  );
};

export const archiveProject = async (status, id) => {
console.log("cscscscsc", id)
  return await axios.put(`${baseUrl}/api/projects/update/archive/${id}?archive=${status}`, {
     headers: {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "multipart/form-data", // Important for sending FormData
      },
  })
}

// User mnaagement

export const getAllSubcontractor = async () => {
  return await axios.get(`${baseUrl}/api/subcontractor/get/all`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const updateSubContractor = async (id, updateData) => {

  // const formData = new FormData();
  // formData.append("domain", updateData.domain);
  // formData.append("active", updateData.status);
  // formData.append("emergencyPhone", updateData.emerPhone);
  // formData.append("street", updateData.street);

  // formData.append("city", updateData.city);
  // formData.append("prov", updateData.prov);

  // formData.append("code", updateData.code);
  // formData.append("homePhone", updateData.homePhone);
  // formData.append("ins", updateData.ins);
  // formData.append("active", updateData.active);

  // formData.append("bus", updateData.bus);
  // formData.append("hst", updateData.hst);
  // formData.append("applyHst", updateData.applyHst);
  // formData.append("hstRate", updateData.hstRate);

  // formData.append("comment", updateData.comment);

  return await axios.patch(
    `${baseUrl}/api/subcontractor/update-by/${id}`,
    updateData,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteSubContractor = async (id) => {
  return await axios.delete(`${baseUrl}/api/subcontractor/delete-by/${id}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const createSubContractor = async (formData) => {
  console.log("formdAata", formData);
  // const formdata = new FormData()
  // formdata.append("firstName", createdData.firstName)
  // formdata.append("email", createdData.email)
  // formdata.append("gender", createdData.gender)
  // formdata.append("phone", createdData.phone)
  // formdata.append("domain", createdData.domain)
  // formdata.append("profileImage", createdData.profileImage)

  return await axios.post(`${baseUrl}/api/subcontractor/register`, formData, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
};


export const getAboutUs = async () => {
  
  return await axios.get(`${baseUrl}/api/about-us/get/all`, {
    headers: {
       "content-Type": "application/json",

      Authorization: `Bearer ${storedToken}`
    },
  });
};

export const createAboutUs = async (formData) => {
  return await axios.post(`${baseUrl}/api/about-us/create`, formData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const updateAboutUs = async (id, formData) => {

  return await axios.put(`${baseUrl}/api/about-us/update/${id}`, formData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const createPrivacyPolicy = async (formData) => {
  return await axios.post(`${baseUrl}/api/privacy-policy/create`, formData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const getPrivacyPolicy = async () => {
  return axios.get(`${baseUrl}/api/privacy-policy/get/all`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "content-Type": "application/json",
    },
  });
};

export const updatePrivacyPolicy = async (id, formData) => {
  return await axios.put(
    `${baseUrl}/api/privacy-policy/update/${id}`,
    formData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
};

export const createTermsAndConditions = async (formData) => {
  return await axios.post(
    `${baseUrl}/api/terms-and-conditions/create`,
    formData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
};

export const getTermsAndConditions = async () => {
  return axios.get(`${baseUrl}/api/terms-and-conditions/get/all`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "content-Type": "application/json",
    },
  });
};

export const updateTermsAndConditions = async (id, formData) => {
  return await axios.put(
    `${baseUrl}/api/terms-and-conditions/update/${id}`,
    formData,
    {
      headers: {
        "content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
};

export const getAssignedProjects = async () => {
  return await axios.get(`${baseUrl}/api/assign-projects/admin`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};

export const assignProject = async (apiData) => {
  // console.log("apiData", apiData);

  return await axios.post(`${baseUrl}/api/assign-projects/create`, apiData, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "application/json",
    },
  });
};


// Invoice API

export const getAllInvoiceDetails = async () => {

  return await axios.get(`${baseUrl}/api/project-invoice/admin`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "application/json",
    },
    // params: apiData, // If you need to send query parameters
  });
};


export const approveAllPendingInvoices = async (data) => {

  return await axios.put(`${baseUrl}/api/project-invoice/update/invoices/paid-status`, data,{
     headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "application/json",
    },
  })
}

export const archiveAllInvoices = async (data) => {

  return await axios.put(`${baseUrl}/api/project-invoice/update/invoices/acceptance-status`, data,{
     headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "application/json",
    },
  })
}


export const editInvoiceDetails = async (updateInvoiceData) => {

  const formData = new FormData()
  if (updateInvoiceData?.projectDetails?.invoiceAccepted) formData.append("invoiceAccepted", updateInvoiceData?.projectInvoice?.invoiceAccepted)
  if (updateInvoiceData?.projectDetails?.paidStatus) formData.append("paidStatus", updateInvoiceData?.projectInvoice?.paidStatus)
  if (updateInvoiceData?.projectDetails?.amountPaid) formData.append("amountPaid", updateInvoiceData?.projectInvoice?.amountPaid)
  if (updateInvoiceData?.projectDetails?.comments) formData.append("comments", updateInvoiceData?.projectInvoice?.comments)
  else {

    formData.append("invoiceAccepted", updateInvoiceData?.projectInvoice?.invoiceAccepted)
    formData.append("paidStatus", updateInvoiceData?.projectInvoice?.paidStatus)
    formData.append("amountPaid", updateInvoiceData?.projectInvoice?.amountPaid)
    formData.append("comments", updateInvoiceData?.projectInvoice?.comments)
  }



  return await axios.put(`${baseUrl}/api/project-invoice/update/${updateInvoiceData?.projectInvoice?.id}`, formData, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "multipart/form-data",
    },
  })
}



export const authDeAuthUsers = async (status) => {

const formData=new FormData();
formData.append("status",status)

return await axios.patch(`${baseUrl}/api/subcontractor/set-status-all`,formData, {
  headers: {
    Authorization: `Bearer ${storedToken}`,
  }
})
}

//quick books

export const addCustomerToQuickBooks = async(formData) => {

  const accessToken = localStorage.getItem("access_token")

  const adminId = localStorage.getItem("userId")

  return await axios.post(`${baseUrl}/api/quickbooks/createCustomer?admin_id=${adminId}`,formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    }
  })
}

export const addServicesToQuickbook = async(formData) => {

  const accessToken = localStorage.getItem("access_token")
  const adminId = localStorage.getItem("userId")

  return await axios.post(`${baseUrl}/api/quickbooks/createServiceItem?admin_id=${adminId}`,formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    }
  })
}

export const getQBCustomerId = async(email) => {

  const accessToken = localStorage.getItem("access_token")
  const adminId = localStorage.getItem("userId")

  return await axios.get(`${baseUrl}/api/quickbooks/customer-by-email?email=${email}&admin_id=${adminId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    }
  })
}

export const getQBServiceId = async(taskName) => {
  const accessToken = localStorage.getItem("access_token")
  const adminId = localStorage.getItem("userId")

  return await axios.get(`${baseUrl}/api/quickbooks/getServiceItemByName?itemName=${taskName}&admin_id=${adminId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    }
  })
}

export const raiseInvoiceOnQB = async(formData) => {

  const accessToken = localStorage.getItem("access_token")
  const adminId = localStorage.getItem("userId")

  return await axios.post(`${baseUrl}/api/quickbooks/createInvoice?admin_id=${adminId}`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    } 
  })
}

export const getAccessTokenFromRefreshToken = async(token) => {
  const adminId = localStorage.getItem("userId")
  return await axios.get(`${baseUrl}/api/quickbooks/refresh-token?refresh_token=${token}&admin_id=${adminId}`, {
    headers: {
      "Content-Type": "application/json",
    }
  })
}



// Forgot password

export const sendOtp = async (otpEmail) => {
 
  let formData = new FormData();
  formData.append("email", otpEmail);

  return await axios.post(`${baseUrl}/api/admin/send-otp`, formData, {
      headers : {
          'Content-Type' : 'application/json'
      }
  })
}

export const verifyOtp = async ({values}) => {

  let formData = new FormData();
  formData.append("email", values.otpEmail)
  formData.append("otp", values.otp)


  return await axios.post(`${baseUrl}/api/admin/verify-otp`, formData, {
      headers : {
          'Content-Type' : 'application/json'
      }
  })

}

export const resetPassword = async ({values}) => {
  let formData = new FormData();

  formData.append("email", values.otpEmail)
  formData.append("newPassword", values.newPassword)
  formData.append("confirmNewPassword", values.confirmPassword)

  return await axios.patch(`${baseUrl}/api/admin/reset-password`, formData, {
      headers : {
          'Content-Type' : 'application/json'
      }
  })

}



export const markCompleteProject = async (id) => {
  return await axios.patch(`${baseUrl}/api/assign-projects/update-status/${id}?status=${"Completed"}`,{}, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
};




export const updateTaskAvailable = async (id, pId, data) => {

  return await axios.put(`${baseUrl}/api/projects/update/${pId}/tasks/${id}`,data,{
    headers : {
      'Content-Type' : 'application/json'
  }
  })
}


export const unassignTask = async (id) => {

  return await axios.delete(`${baseUrl}/api/assign-projects/un-assign/${id}`, {
    headers : {
      Authorization: `Bearer ${storedToken}`,
      'Content-Type' : 'application/json'
  }
  })
}




// Support Staff Apis

export const getSupport = async () => {

  return await axios.get(`${baseUrl}/api/get/all-office-support`, {
    headers : {
      Authorization: `Bearer ${storedToken}`,
      'Content-Type' : 'application/json'
  }
  })
}


export const createStaff = async (data) => {

  return await axios.post(`${baseUrl}/api/auth/register-office-support`, data,{
    headers : {
      Authorization: `Bearer ${storedToken}`,
      'Content-Type' : 'application/json'
  }
  })
}

export const updateStaff = async (id, data) => {

  return await axios.patch(`${baseUrl}/api/update-office-support-by/${id}`, data,{
    headers : {
      Authorization: `Bearer ${storedToken}`,
      'Content-Type' : "multipart/form-data"
  }
  })
}


export const deleteStaff = async (id) => {

  return await axios.delete(`${baseUrl}/api/delete-office-support-by/${id}`, {
    headers : {
      Authorization: `Bearer ${storedToken}`,
      'Content-Type' : 'application/json'
  }
  })
}